/**
 * Studio Orchestration V2 — Landing. Design-time: Rule Sets, Process Templates, Handlers, Publications.
 */

import { Layers, FileStack, Cpu, History } from "lucide-react";
import { AppShell } from "../../layouts/AppShell";

type StudioLandingPageProps = {
  userName?: string;
  onBackToDashboard?: () => void;
  onOpenRuleSets?: () => void;
  onOpenProcessTemplates?: () => void;
  onOpenHandlers?: () => void;
  onOpenPublications?: () => void;
};

export function StudioLandingPage({
  userName = "Utilisateur",
  onBackToDashboard,
  onOpenRuleSets,
  onOpenProcessTemplates,
  onOpenHandlers,
  onOpenPublications,
}: StudioLandingPageProps) {
  const cards = [
    {
      title: "Rule Sets",
      subtitle: "Règles produit → processus, versions, publication",
      icon: Layers,
      onClick: onOpenRuleSets,
    },
    {
      title: "Process Templates",
      subtitle: "Modèles de processus (étapes, activités)",
      icon: FileStack,
      onClick: onOpenProcessTemplates,
    },
    {
      title: "Handlers",
      subtitle: "Registre des types d'activités (lecture seule)",
      icon: Cpu,
      onClick: onOpenHandlers,
    },
    {
      title: "Publications",
      subtitle: "Historique des publications et audit",
      icon: History,
      onClick: onOpenPublications,
    },
  ];

  return (
    <AppShell
      userName={userName}
      topbar={
        <div className="flex items-center gap-4">
          {onBackToDashboard && (
            <button
              type="button"
              onClick={onBackToDashboard}
              className="text-sm text-muted hover:text-text"
            >
              Tableau de bord
            </button>
          )}
          <span className="text-sm font-medium text-text">Studio</span>
        </div>
      }
    >
      <div className="ds-container py-8">
        <h1 className="text-xl font-semibold text-text mb-2">Studio</h1>
        <p className="text-sm text-muted mb-6">
          Configuration design-time : Rule Sets, Process Templates, Handlers et audit des publications.
        </p>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 max-w-5xl">
          {cards.map((card) => {
            const Icon = card.icon;
            return (
              <button
                key={card.title}
                type="button"
                onClick={card.onClick}
                className="flex items-start gap-4 rounded-lg border border-border bg-surface p-5 text-left shadow-sm transition hover:border-primary/30 hover:shadow"
              >
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
                  <Icon className="h-5 w-5" />
                </div>
                <div>
                  <div className="font-medium text-text">{card.title}</div>
                  <div className="mt-1 text-sm text-muted">{card.subtitle}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </AppShell>
  );
}
